var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckcircleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_279_49",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 58,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 58.6673C35.5028 58.6719 38.9717 57.9842 42.2077 56.6438C45.4436 55.3033 48.3827 53.3366 50.8562 50.8567C53.3361 48.3832 55.3028 45.4441 56.6433 42.2081C57.9837 38.9722 58.6714 35.5033 58.6668 32.0007C58.6713 28.4981 57.9836 25.0292 56.6432 21.7932C55.3028 18.5573 53.3361 15.6181 50.8562 13.1447C48.3827 10.6647 45.4436 8.698 42.2077 7.35759C38.9717 6.01717 35.5028 5.32947 32.0002 5.33401C28.4976 5.32954 25.0287 6.01728 21.7928 7.35769C18.5568 8.6981 15.6177 10.6648 13.1442 13.1447C10.6643 15.6181 8.69761 18.5573 7.3572 21.7932C6.01679 25.0292 5.32905 28.4981 5.33352 32.0007C5.32898 35.5033 6.01668 38.9722 7.3571 42.2081C8.69752 45.4441 10.6642 48.3832 13.1442 50.8567C15.6177 53.3366 18.5568 55.3032 21.7928 56.6437C25.0287 57.9841 28.4976 58.6718 32.0002 58.6673Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 32L29.3335 40L45.3335 24",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_279_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "#047716"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircleicon);
export default __webpack_public_path__ + "static/media/checkcircleicon.2c422e1ffe53763a58713ee1656ee4c1.svg";
export { ForwardRef as ReactComponent };